import BaseType from "../BaseType";
import LocalizationGroup from "./LocalizationGroup";

export default class LocalizationKey extends BaseType {
  LocalizationGroupId: string = "";
  LocalizationGroup: LocalizationGroup = new LocalizationGroup();
  Key: string = "";
  Localizations: any = {};
}
